// extracted by mini-css-extract-plugin
export var hovered = "styles-module--hovered--e8a5b";
export var imageContainer = "styles-module--imageContainer--caeda";
export var linkContainer = "styles-module--linkContainer--8eb10";
export var linkPill = "styles-module--linkPill--cef55";
export var title = "styles-module--title--47d69";
export var video = "styles-module--video--33786";